module.exports = __webpack_public_path__ + "img/whostalkin.7c6566b1.png";